import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { CTA_CONTENT_CARDS } from 'src/shared/static';
import { CtaContentCardsProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';
import { C20CTAContentCardsProps } from './C20CTAContentCards.types';

export function CreateCTAContentCardsModel(props?: C20CTAContentCardsProps) {
  type t = CtaContentCardsProps;
  const { fields, params, rendering } = props || {};
  const { renderRichText, renderLink, renderText } = useConditionalRendering();

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    cta: renderLink(fields?.CTA),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    numColumns: getDroplink<t['numColumns']>(params?.NumberOfColumns, '2'),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentAlignment, 'center'),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundColor, 'white'),
    hasDropShadows: params?.EnableDropshadow,
    contentCards: rendering ? (
      <Placeholder name={CTA_CONTENT_CARDS} rendering={rendering} />
    ) : (
      <></>
    ),
  };
}
